import React, { PureComponent } from 'react';
import queryString from 'query-string';

import './style.scss';
import { apiGet, apiPost, headers } from '../../util/api';
import NormalSlide from './NormalSlide/NormalSlide';
import ErrorMessageScreen from './ErrorMessageScreen/ErrorMessageScreen';
import Loader from '../Loader/Loader';

class Carousel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      error: '',
      currentSlideIndex: 0,
      carouselContainerWidth: undefined,
      moduleData: [],
      moduleName: '',
    };

    this.carouselUiRef = '';
    this.moduleId = window.location.pathname.split('/')[1];
    ({
      uid: this.uid,
      token: this.token,
      role: this.role,
    } = queryString.parse(window.location.search));
    headers.set('Session-Token', this.token);
  }

  componentDidMount() {
    apiGet(
      this.role === 'admin'
        ? `v1/student/single/flashcard/${this.moduleId}/data/`
        : `v1/student/${this.uid}/generate/module/${this.moduleId}/`
    ).then((res) => {
      if (res.data) {
        const {
          flashcard_data: moduleData,
          current_flashcard_index: currentSlideIndex,
          module_name: moduleName,
        } = res.data;

        this.setState({
          moduleData: moduleData || [],
          currentSlideIndex: currentSlideIndex || 0,
          moduleName,
          loader: false,
        });
        if (
          this.role !== 'admin' &&
          !moduleData[currentSlideIndex].is_read &&
          moduleData[currentSlideIndex]?.one_time_allowed_elements?.[
            'single-select'
          ] !== true
        )
          this.syncSlides({
            flashcard_id: moduleData[currentSlideIndex].flashcard_id,
            is_read: true,
          });
      } else {
        if (res.error === 'Invalid Module')
          this.setState({ error: 'Flashcard not found!', loader: false });
        else this.setState({ error: res.error, loader: false });
      }
    });

    window.addEventListener('resize', () => this.handleResize());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.handleResize());
  }

  syncSlides = (syncData, submitAnswer = false) => {
    if (this.role !== 'admin') {
      apiPost(`v1/student/${this.uid}/module/${this.moduleId}/sync/`, {
        flashcards: [syncData],
      }).then((res) => {
        const { moduleData, currentSlideIndex } = this.state;

        if (res.data) {
          if (submitAnswer) {
            const updatedModuleData = JSON.parse(JSON.stringify(moduleData));
            updatedModuleData[currentSlideIndex].user_response =
              syncData.user_response;

            this.setState({ moduleData: updatedModuleData });
          } else {
            const updatedModuleData = JSON.parse(JSON.stringify(moduleData));
            updatedModuleData[currentSlideIndex].is_read = true;

            this.setState({ moduleData: updatedModuleData });
          }
        }
      });
    }
  };

  handleResize = (node) => {
    if (this.carouselUiRef === '' && node !== undefined)
      this.carouselUiRef = node;
    this.setState({
      carouselContainerWidth: this.carouselUiRef.offsetWidth || 0,
    });
  };

  nextSlide = () => {
    const { currentSlideIndex, moduleData } = this.state;

    if (currentSlideIndex < moduleData.length - 1) {
      this.setState({ currentSlideIndex: currentSlideIndex + 1 }, () => {
        const { currentSlideIndex, moduleData } = this.state;

        if (
          this.role !== 'admin' &&
          !moduleData[currentSlideIndex].is_read &&
          moduleData[currentSlideIndex]?.one_time_allowed_elements?.[
            'single-select'
          ] !== true
        )
          this.syncSlides({
            flashcard_id: moduleData[currentSlideIndex].flashcard_id,
            is_read: true,
          });
      });
    }
  };

  prevSlide = () => {
    this.setState((prevState) => ({
      currentSlideIndex: prevState.currentSlideIndex - 1,
    }));
  };

  render() {
    const {
      loader,
      error,
      moduleName,
      currentSlideIndex,
      moduleData,
      carouselContainerWidth,
    } = this.state;

    return (
      <div className='carousel-outer-container'>
        <div className='carousel-title-box'>
          <p className='carousel-heading'>Revision Hop</p>
          <p className='carousel-title'>{moduleName}</p>
        </div>
        <div className='carousel-inner-container'>
          <div className='carousel-box'>
            {currentSlideIndex !== 0 && (
              <div className='prev-arrow' onClick={this.prevSlide}>
                <svg
                  width='9'
                  height='18'
                  viewBox='0 0 10 18'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8.53505 0.514648L0.0500488 8.99965L8.53505 17.4846L9.95005 16.0706L2.87805 8.99965L9.95005 1.92865L8.53505 0.514648Z'
                    fill='#2E3A59'
                  />
                </svg>
              </div>
            )}
            {moduleData.length > 0 &&
              currentSlideIndex !== moduleData.length - 1 &&
              (moduleData[currentSlideIndex]?.one_time_allowed_elements?.[
                'single-select'
              ]
                ? moduleData[currentSlideIndex].user_response !== null
                : true) && (
                <div className='next-arrow' onClick={this.nextSlide}>
                  <svg
                    width='9'
                    height='18'
                    viewBox='0 0 10 18'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M1.46495 0.515625L9.94995 9.00062L1.46495 17.4856L0.0499516 16.0716L7.12195 9.00062L0.0499516 1.92963L1.46495 0.515625Z'
                      fill='#2E3A59'
                    />
                  </svg>
                </div>
              )}
            <div className='carousel-ui'>
              {loader ? (
                <Loader />
              ) : error ? (
                <ErrorMessageScreen text={error} showSupportText />
              ) : moduleData.length !== 0 ? (
                <>
                  <div className='stepper-box'>
                    {Array.from({ length: moduleData.length }).map(
                      (item, index) => (
                        <div
                          key={index}
                          className={
                            currentSlideIndex === index ? 'step active' : 'step'
                          }
                        />
                      )
                    )}
                  </div>
                  <div
                    className='carousel-slides'
                    style={{
                      width: '100%',
                      transform: `translate3d(${-(
                        carouselContainerWidth * currentSlideIndex
                      )}px,0px,0px)`,
                    }}
                    ref={this.handleResize}
                  >
                    {moduleData.map((slide, index) => (
                      <NormalSlide
                        key={index}
                        {...{
                          ...slide,
                          slideIndex: index,
                          nextSlide: this.nextSlide,
                          syncSlides: this.syncSlides,
                        }}
                      />
                    ))}
                  </div>
                </>
              ) : (
                <ErrorMessageScreen text='Data Not Found!' />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Carousel;
